import React from 'react';

const useNewPairsTableData = ({pairs}: any) => {

  // table memoized required fields
  const data = React.useMemo(
    () => pairs,
    [pairs]
  );
  const columns = React.useMemo(
    () => [
      // {
      //   id: 'chain',
      //   Header: 'Chain',
      //   accessor: 'chain',
      // },
      {
        id: 'name',
        Header: 'Pair',
        accessor: 'name',
      },
      {
        id: 'pool_created',
        Header: 'Listed since',
        accessor: 'pool_created',
      },
      {
        id: 'priceUSD',
        Header: 'Token price USD',
        accessor: 'price_a_usd',
      },
      {
        id: 'liquidity',
        Header: 'Total liquidity',
        accessor: 'liquidity',
      },
      {
        id: 'base_reserve',
        Header: 'Pool Base',
        accessor: 'base_reserve',
      },
      {
        id: 'quote_reserve',
        Header: 'Pool quote',
        accessor: 'quote_reserve',
      },
      {
        id: 'contract',
        Header: 'Contract',
        accessor: 'address',
      },
    ], []
  );

  return {columns, data};
};

export { useNewPairsTableData };

